function toggleElementFullscreen(element) {
  const DOMElement = document.querySelector(element);
  if (DOMElement) {
    if (DOMElement.requestFullscreen) {
      DOMElement.requestFullscreen();
    } else if (DOMElement.mozRequestFullScreen) {
      DOMElement.mozRequestFullScreen();
    } else if (DOMElement.webkitRequestFullscreen) {
      DOMElement.webkitRequestFullscreen();
    } else if (DOMElement.msRequestFullscreen) {
      DOMElement.msRequestFullscreen();
    }
  } else {
    throw new Error('element not found on DOM');
  }
}

export default toggleElementFullscreen;
